import { FaWhatsapp } from "react-icons/fa";
import "./FloatingContactButton.css";

export default function FloatingContactButton() {

  const whatsappNumber = "+919503873735";

  return (
    <a
      href={`https://wa.me/${whatsappNumber}`}
      target="_blank"
      rel="noopener noreferrer"
      className="wa-float"
    >
      <FaWhatsapp />
    </a>
  );
}